import $ from 'jquery'
import debounce from '../utils/debounce'

const $scrollNote = $('.js-scroll-note')

$(window).on('resize', debounce(function () {
  $scrollNote.css({
    bottom: 'auto',
    top: $('.js-hero').outerHeight() - $scrollNote.outerHeight()
  })
}))

$scrollNote.on('click', function () {
  $('html,body').animate({ scrollTop: $(window).innerHeight() }, 1000, 'swing')
})
